// ---------------------------------------------- modules import
import M from "materialize-css";
import React, { FunctionComponent, MouseEvent, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { ILoggedInProps } from "./common";
import { ThemeContext } from "../../contexts/themeContext";
import { thunkLogout } from "../../store/auth/thunkActions";

// ---------------------------------------------- the component
const LoggedIn: FunctionComponent<ILoggedInProps> = ({ profile }) => {
  // ---------------------------------------------- redux connect
  const dispatch = useDispatch();

  // ---------------------------------------------- handlers
  const handleLogout = (e: MouseEvent) => {
    e.preventDefault();

    dispatch(thunkLogout());
  };

  // ---------------------------------------------- effects
  useEffect(() => {
    const dropdowns = document.querySelectorAll(".dropdown-trigger");

    M.Dropdown.init(dropdowns, { coverTrigger: false });
  }, []);

  // ---------------------------------------------- content
  return (
    <ThemeContext.Consumer>
      {({ theme }) => (
        <li>
          <a
            className="dropdown-trigger"
            href="#!"
            data-target="navbar-dropdown"
            style={{ color: theme.syntax }}
          >
            {profile.name}

            <i className="material-icons right">arrow_drop_down</i>
          </a>

          <ul
            id="navbar-dropdown"
            className="dropdown-content"
            style={{ backgroundColor: theme.ui }}
          >
            <li>
              <Link to="/" style={{ color: theme.syntax, fontSize: "0.95em" }}>
                Dashboard
              </Link>
            </li>

            {profile.isSuper ? null : (
              <li>
                <Link
                  to="/user-settings"
                  style={{ color: theme.syntax, fontSize: "0.95em" }}
                >
                  Settings
                </Link>
              </li>
            )}

            <li>
              <a
                href="/"
                onClick={handleLogout}
                style={{ color: theme.syntax, fontSize: "0.95em" }}
              >
                Logout
              </a>
            </li>
          </ul>
        </li>
      )}
    </ThemeContext.Consumer>
  );
};

export default LoggedIn;
